import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import CreditCardInput from './Form/CreditCardInput';
import ExpirationDateInput from './Form/ExpirationDateInput';
import CvvInput from './Form/CvvInput';
import PostalCodeInput from './Form/PostalCodeInput';
import Button from '../Button';
import TwoGroup from '../TwoGroup';
import ButtonGroup from './Form/ButtonGroup';
import FullNameInput from './Form/FullNameInput';
import EmailInput from './Form/EmailInput';

import GetUpdatesCheckbox from '../Widget/GetUpdatesCheckbox';
import LegalInfo from '../Widget/LegalInfo';

import validate from './Form/validations';
import { getCachedFullName } from '../../utils/formCaching/helpers';

const DetailsFormContainer = styled.form`
    flex: 1;
    padding: 1em;
    display: flex;
    flex-direction: column;
`;

const FormGroup = styled.div`
    margin-bottom: 1.4em;
`;

const FormGroupWrapper = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    margin: 0 -0.5em;

    > div {
        flex: 1;
        display: flex;
        flex-direction: column;
        margin: 0 0.5em;
    }
`;

const DetailsForm = props => (
    <DetailsFormContainer onSubmit={props.handleSubmit} autocomplete="on">
        <FormGroup>
            <TwoGroup>
                <FullNameInput autoFocus={true} />
                <EmailInput />
            </TwoGroup>
        </FormGroup>
        <FormGroup>
            <CreditCardInput />
        </FormGroup>
        <FormGroup>
            <TwoGroup>
                <ExpirationDateInput />
                <CvvInput />
                <PostalCodeInput />
            </TwoGroup>
        </FormGroup>
        <FormGroup>
            <FormGroupWrapper>
                <GetUpdatesCheckbox />
                <LegalInfo align="right" />
            </FormGroupWrapper>
        </FormGroup>
        <ButtonGroup>
            <TwoGroup>
                <Button label="Back" onClick={props.onBackToAmount} />
                <Button
                    primary={true}
                    label={`Give ${props.amountFormated}`}
                    type="submit"
                    disabled={props.submitting || props.invalid}
                />
            </TwoGroup>
        </ButtonGroup>
    </DetailsFormContainer>
);

DetailsForm.propTypes = {
    onBackToAmount: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    invalid: PropTypes.bool.isRequired,
    amountFormated: PropTypes.string.isRequired,
    partnerName: PropTypes.string.isRequired
};

export default compose(
    connect(state => {
        return {
            initialValues: {
                getUpdates: true,
                fullName: getCachedFullName(state),
                email: state.cachedFormData.email || '',
                postalCode: state.cachedFormData.postalCode || ''
            }
        };
    }),
    reduxForm({
        form: 'donationDetailsForm',
        validate
    })
)(DetailsForm);



// WEBPACK FOOTER //
// ./src/components/Donation/DetailsForm.jsx